// Excel and Word files stored next to images on CRM records (KRAN quotes first).
// The gallery renders them in the browser: SheetJS for spreadsheets,
// docx-preview for .docx. Legacy .doc has no browser renderer, so it gets a
// download card instead.

const SPREADSHEET_EXT_RE = /\.(xlsx|xls|csv)(?:$|\?)/i;
const WORD_EXT_RE = /\.(docx|doc)(?:$|\?)/i;
const LEGACY_DOC_EXT_RE = /\.doc(?:$|\?)/i;

/** 'spreadsheet' | 'word' | null, from a url or a file name. */
export const getOfficeDocKind = (urlOrName) => {
  const value = String(urlOrName || '');
  if (SPREADSHEET_EXT_RE.test(value)) return 'spreadsheet';
  if (WORD_EXT_RE.test(value)) return 'word';
  return null;
};

export const isLegacyWordDoc = (urlOrName) => LEGACY_DOC_EXT_RE.test(String(urlOrName || ''));

/** Kind of an uploaded File, by MIME type first and extension second. */
export const getOfficeFileKind = (file) => {
  const type = file?.type || '';
  if (
    type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    || type === 'application/vnd.ms-excel'
    || type === 'text/csv'
  ) return 'spreadsheet';
  if (
    type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    || type === 'application/msword'
  ) return 'word';
  return getOfficeDocKind(file?.name);
};

/** react-dropzone `accept` entries for Excel and Word. */
export const OFFICE_DOCUMENT_ACCEPT = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-excel': ['.xls'],
  'text/csv': ['.csv'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/msword': ['.doc'],
};

/** Dropzone props for uploads that take images, PDF, video, Excel and Word. */
export const MEDIA_AND_OFFICE_UPLOADER_PROPS = {
  accept: {
    'image/*': ['.jpeg', '.jpg', '.png', '.webp', '.gif'],
    'application/pdf': ['.pdf'],
    'video/*': ['.mp4', '.mov', '.webm'],
    ...OFFICE_DOCUMENT_ACCEPT,
  },
  label: 'Trage și plasează imagini, PDF, Excel, Word sau video aici, sau click pentru a selecta',
  hint: 'Imagini: 10MB • PDF, Excel, Word: 20MB • Video (MP4/WEBM/MOV): 100MB',
};
